import { useHistory } from 'react-router';

import { Button, Icon, Text } from '../../Atoms';

function TemplateResiliationSuccess(props) {
  const history = useHistory();
  return (
    <div>
      <div className='cartetp-header-container '>
        <Text text='Demande de Résiliation' type='h4' />
      </div>
      <div className='container-hospitalisation success-step-hospitalisation' style={{ marginTop: 120 }}>
        <Text text='Votre demande de résiliation a bien été envoyée.' type='h7' />
        <div className='success-icon-container'>
          <Icon icon='Valid' size={40} color='green' />
        </div>
      </div>
      <div className='hospitalisation-button-home-container'>
        <Button
          text='Revenir au tableau de bord'
          className='submit-btn-modal-calendar'
          boxShadow
          onClick={() => history.push('/')}
        />
      </div>
    </div>
  );
}

export default TemplateResiliationSuccess;
